import { MAX_COUNT_FOR_API_REQUEST } from '@helpers/interfaces/api';
import { Plan, sumInsuredOptions, policyTerms, paymentFrequencies, insuranceTypes } from '@helpers/interfaces/plan';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Interface of slice
interface PlanState{
  value:Plan
}



const initialState: PlanState = {
  value: {
    leadId:"",
    paymentFrequency:paymentFrequencies.Annual.value,
    sumInsured:sumInsuredOptions.lac3.value,
    insuranceType:insuranceTypes.Indiv.value,
    ageGroup:null,
    planPerHead:0,
    planTotal: 0, 
    numberOfEmployees: 0,
    policyTerm: policyTerms.Std.value,
  }
};

export const PlanSlice = createSlice({
  name: "Plan",
  initialState,
  reducers: {
    setSumInsured: (state: PlanState, action: PayloadAction<number>) => {
      state.value.sumInsured = action.payload
    },
    setNumberOfEmployees: (state: PlanState, action: PayloadAction<string>) => {
      state.value.numberOfEmployees = +action.payload < MAX_COUNT_FOR_API_REQUEST ? +action.payload : MAX_COUNT_FOR_API_REQUEST 
    },
    setAgeGroup:(state:PlanState, action:PayloadAction<number[]>)=>{
      state.value.ageGroup = action.payload
    },
    setPolicyTerm:(state:PlanState, action:PayloadAction<string>)=>{
      state.value.policyTerm = action.payload
    },
    setPaymentFrequency:(state:PlanState, action:PayloadAction<string>)=>{
      state.value.paymentFrequency = action.payload
    },
    setInsuranceType:(state:PlanState, action:PayloadAction<string>)=>{
      state.value.insuranceType = action.payload
    },
    setLeadId: (state: PlanState, action: PayloadAction<string>) => {
      state.value.leadId = action.payload;
    },
  }
});

export const {
  setPaymentFrequency,
  setNumberOfEmployees,
  setSumInsured,
  setAgeGroup,
  setPolicyTerm,
  setInsuranceType,
  setLeadId
} = PlanSlice.actions;

export default PlanSlice.reducer;
